import { createFileRoute, Link } from "@tanstack/react-router";
import { ADRS } from "@/content/adr";

export const Route = createFileRoute("/admin/references")({
  component: ReferencesIndex,
});

function ReferencesIndex() {
  return (
    <div className="space-y-6">
      <div>
        <p className="overline mb-2">Reference library</p>
        <h2 className="font-serif text-2xl text-primary">Architecture decision records</h2>
        <p className="text-ink-secondary text-sm mt-2 max-w-2xl">
          Engineering decisions that shape how Tiger&apos;s Eye reasons, retrieves and learns.
          Each ADR captures the context, the choice, the rejected alternatives and the
          conditions that would justify revisiting the call.
        </p>
      </div>

      <ul className="border border-border bg-card divide-y divide-border">
        {ADRS.map((adr) => (
          <li key={adr.id}>
            <Link
              to="/admin/references/$id"
              params={{ id: adr.id }}
              className="block p-5 hover:bg-muted/50"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-xs text-ink-tertiary">{adr.number}</span>
                <span className="text-xs text-ink-tertiary">{adr.date}</span>
              </div>
              <p className="font-serif text-lg text-primary mt-1">{adr.title}</p>
              <p className="text-xs font-mono text-ink-secondary mt-1">{adr.status}</p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
